import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import SpinnerLottie from '../spinnerLottie';

import { useStyles } from './styles';

function TransitionAvatar (props) {
    const {
        calendarLogoURL = '',
        clientLogoURL = '',
        marginTop = '0px',
        marginInBetween = '-50px',
        isOauthFailing = false,
    } = props;

    const classes = useStyles({
        marginTop,
        marginInBetween,
        isOauthFailing,
        clientLogoURL,
    });

    return (
        <React.Fragment>
            <Grid
                id='Oauth-Avatars'
                className={classes.container}
            >
                <Avatar
                    id='Calendar-Oauth-Avatar'
                    className={classes.avatarIcon}
                    alt='Calendar Logo'
                    src={calendarLogoURL}
                    sx={{ height: '45px', width: '45px' }}
                />

                {!isOauthFailing && <SpinnerLottie className={classes.loadingIconStyling} />}

                <Avatar
                    id='Client-Oauth-Avatar'
                    className={classNames([classes.avatarIcon, classes.clientAvatarIcon])}
                    alt='Client Logo'
                    src={clientLogoURL}
                    sx={{ height: '48px', width: '48px' }}
                />
            </Grid>         
        </React.Fragment>
    );
}

TransitionAvatar.propTypes = {
    calendarLogoURL: PropTypes.string,
    clientLogoURL: PropTypes.string,
    marginTop: PropTypes.string,
    marginInBetween: PropTypes.string,
    isOauthFailing: PropTypes.bool,
};

export default TransitionAvatar;
